<div class="select-client-container">
  <!-- <div class="close-client" (click)="onClientClose($event)">
    <img src="assets/icons/miscellaneous/icon-cross.svg" height="30" width="30" alt="❌">
  </div> -->
  <div class="client-container">
    <h2 class="text-align-center mb-20">{{'Select your client' | uppercase}}</h2>
    <div role="list" class="clients-list">
      <div *ngFor="let client of allClients" role="listitem" class="client-list-item" [ngClass]="{'selected': client.unique_key === currentClient?.unique_key}" (click)="onSelectClient($event, client)">
        <div *ngIf="client.logo_image; else noLogo;" class="client-logo" [ngStyle]="{'background-image': 'url(' + client.logo_image + ')'}"></div>
        <ng-template #noLogo>
          <p class="no-client-logo">No company logo preview</p>
        </ng-template>
        <p class="client-title">{{ client.name }}</p>
      </div>
    </div>
  </div>
</div>
